import { setPostId } from "./modules/setPostId";

const blog = document.querySelector(".blog-content");
const postId = blog.dataset.postId;

setPostId(postId);
